import {z} from 'zod'

export const AdminUser = z.object({
    id: z.number().int().positive(),
    first_name: z.string(),
    last_name: z.string()
})
export type AdminUser = z.infer<typeof AdminUser>

export const ImpersonateExchangeResponse = z.object({
    access_token: z.string(),
    admin_access_token: z.string()
})
export type ImpersonateExchangeResponse = z.infer<typeof ImpersonateExchangeResponse>
